import React, {useState} from 'react'
import {ApiKeyRead} from "../../Models/models";
import DeleteIcon from "@mui/icons-material/Delete";
import {Alert, Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import './DeleteApiKey.css'
import Typography from "@mui/material/Typography";
import {useDeleteApiKeyMutation} from "../../Redux/api-key-management-api";
import {SnackbarMode, useGlobalSnackbar} from "../Snackbar/useGlobalSnackbar";

type Props = {
    apiKey: ApiKeyRead
}

const DeleteApiKey: React.FC<Props> = ({apiKey}) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const [deleteApiKeys] = useDeleteApiKeyMutation();

    const handleOpen = () => setOpenDialog(true)
    const handleClose = () =>  setOpenDialog(false)

    const {showSnackbar} = useGlobalSnackbar()


    const onSubmit = () => {
        try{
            deleteApiKeys(apiKey.apiKeyId).finally(() => {
                handleClose()
                showSnackbar("Deleted", SnackbarMode.SUCCESS)
            })

        } catch (e) {
            handleClose()
            showSnackbar("Failed. Please try again", SnackbarMode.ERROR)
        }

    }



    return(
        <React.Fragment>
            <IconButton onClick={handleOpen}>
                <DeleteIcon color="error"/>
            </IconButton>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'md'}
            >
                <DialogTitle sx={{padding: 0}}>
                    <Typography fontSize={24} className="dialogHeader">Delete API-Key '{apiKey.name}'</Typography>
                </DialogTitle>
                <DialogContent>
                    <div>
                        <Alert severity="warning">Deleted keys cannot be restored!</Alert>

                        <div style={{display: 'flex', justifyContent: 'end', marginTop: '10px', gap: 10}}>
                            <button type="button" onClick={handleClose} className="button button--secondary" >Cancel</button>
                            <button type="button" onClick={onSubmit} className="button button--danger" >Delete</button>
                        </div>

                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export {DeleteApiKey}